<template>
  <div class="video-player-wrapper">
    <gs:video-vod
      v-if="playType === PlayTypeEnum.Vod"
      :site="site"
      group="default"
      :bgimg="posterImg"
      :btnimg="playBtnImg"
      :ownerid="videoSourceId"
      :uname="uname"
      :authcode="authcode"
      :py="py"
    />
    <gs:video-live
      v-else
      :site="site"
      group="default"
      :bgimg="posterImg"
      :btnimg="playBtnImg"
      :ownerid="videoSourceId"
      :uname="uname"
      :authcode="authcode"
      :py="py"
    />
  </div>
</template>
<script>
import Vue from 'vue'
import { reactive, toRefs, onMounted, watchEffect } from '@vue/composition-api'
import http from '@/api/http'
import appInfo from '@/assets/js/appInfo'
import util from '@/util/util'

Vue.config.ignoredElements = ['gs:video-vod', 'gs:video-live']

const coverImage =
  appInfo.getParam('coverImage') ||
  'https://appstatic.emoney.cn/images/20210609/6e93d948c84f9742fff3855e2dfbf97d.png'

const PlayTypeEnum = {
  /**
   * 直播
   */
  Live: 101,
  /**
   * 录播
   */
  Vod: 100
}

export default {
  name: 'GenseeVideoPlayer',
  components: {},
  props: {
    autoPlay: {
      type: Boolean,
      default: false
    },
    videoId: {
      type: String
    },
    /**
     * 视频地址
     */
    src: {
      type: String
    },
    playBtnImg: {
      type: String,
      default:
        'https://appstatic.emoney.cn/images/20210728/982373a11046c7f51f012a978e53ac2d.png'
    },
    posterImg: {
      type: String,
      default: coverImage
    }
  },
  setup(props) {
    const state = reactive({
      PlayTypeEnum,
      ownerid: '',
      py: 1,
      site: 'emoney.gensee.com',
      playType: PlayTypeEnum.Vod,
      authcode: '',
      uname: '',
      loadedVideoId: '',
      videoSourceId: ''
    })

    function getVideoDetail(videoId) {
      return http.get('/video/play/GetPlayInfo', {
        videoId
      })
    }

    watchEffect(() => {
      let videoId = props.videoId
      if (!videoId && props.src) {
        const res = /-([a-z0-9]+)$/i.exec(props.src)
        if (res && res[1]) {
          videoId = res[1]
        } else {
          videoId = this.src
        }
      }

      if (videoId) {
        state.ownerid = videoId
        setTimeout(() => {
          if (state.loadedVideoId === videoId) {
            // 已加载过的不再重复加载
            return
          }
          state.loadedVideoId = videoId

          getVideoDetail(videoId).then(({ result, detail }) => {
            if (result.code === 0 && detail) {
              let videoInfo = detail
              if (detail.vodList && detail.vodList.length) {
                videoInfo = detail.vodList[0]
              }
              state.videoSourceId = videoInfo.id
              state.site = videoInfo.domain
              state.playType = videoInfo.type
              state.authcode = videoInfo.password
              state.uname = videoInfo.username

              const scriptDom = document.createElement('script')
              scriptDom.async = true
              scriptDom.src =
                'https://static.gensee.com/webcast/static/sdk/js/gssdk.js'
              scriptDom.onload = function() {
                try {
                  const channel = window.GS.createChannel('default')

                  if (state.playType === PlayTypeEnum.Vod) {
                    channel.bind('onDataReady', function(payload) {
                      console.log('onDataReady:', payload)

                      if (props.autoPlay) {
                        channel.send('play')
                      }
                    })
                  }

                  // 直播api，直播开启
                  channel.bind('onStart', function(payload) {
                    console.log('onStart:', payload)
                    if (props.autoPlay) {
                      channel.send('submitPlay')
                    }
                  })

                  channel.bind('onStatus', function(payload) {
                    console.log('onStatus:', payload)
                  })

                  channel.bind('onPlay', function(payload) {
                    console.log('onPlay:', payload)
                  })

                  channel.bind('onStop', function(payload) {
                    console.log('onStop:', payload)
                  })
                } catch (e) {
                  console.error(e)
                }
              }

              document.head.appendChild(scriptDom)
            } else {
              state.loadedVideoId = ''
            }
          })
        }, 50)
      }
    })

    onMounted(() => {
      // 关闭浮窗视频，避免与播放器叠加
      util.closeFloatVideo()
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.video-player-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  max-width: 100%;
  height: 386px;
  overflow: hidden;
  z-index: 100;
}

.video-player {
  height: 100%;
  background: no-repeat center;
  background-size: cover;
}

.play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  background: url('./images/icon-play.png') no-repeat center;
  background-size: contain;
}
</style>
